import React from 'react';
import Form from '../../../CommonComponents/Form';
import { Input } from '../../../CommonComponents/OPL/Input/Input';
import { InputNumberMask } from '../../../CommonComponents/OPL/Input/InputNumberMask';
import withForm from './withForm';

const BusinessAssetForm = ({ account, onUpdate, isEditable }) => (
  <Form>
    <Form.Control>
      <InputNumberMask
        label="Market Value"
        leftIcon="fa fa-dollar-sign"
        allowNegative={false}
        disabled={!isEditable || account.UseUnderlyingAssetsForValue}
        value={account.Value}
        onChange={({ target: { value } }) => onUpdate({ Value: value })}
      />
    </Form.Control>
    <Form.Control>
      <Input
        label="Business Name"
        disabled={!isEditable}
        value={account.Name}
        onChange={({ target: { value } }) => onUpdate({ Name: value })}
      />
    </Form.Control>
  </Form>
);

export default withForm(BusinessAssetForm);
